(function($) {

	$.fn.minimumField = function() {

		var elem = $(this),
			minCount = 0,
			settings = {
				disabledClass: 'is-disabled',
				hiddenFieldClass: 'hidden-field',
				minAttribute: 'data-min'
			};

		var init = function() {

			// Make sure it's a select because otherwise this module would be pointless
			if(elem.prop('tagName').toString().toLowerCase() == 'select') {

				// Parse min count from elem if it has it
				if(elem.attr(settings.minAttribute)) {
					minCount = parseInt(elem.attr(settings.minAttribute));
				}

				// If there are not enough items, disable
				if(elem.find('option').length < minCount) {

					elem.attr('disabled', 'disabled');

					if(elem.hasClass(settings.hiddenFieldClass)) {
						elem.parent().addClass(settings.disabledClass);
					}
				}

				// Make sure it's enabled if the count is satisfactory
				else {

					elem.removeAttr('disabled');

					if(elem.hasClass(settings.hiddenFieldClass)) {
						elem.parent().removeClass(settings.disabledClass);
					}
				}
				
			}

		};

		init();
		return this;
	};

}($));